import React from 'react'
import { Box, useTheme, Button, Typography } from "@mui/material";
import { tokens } from "../../../assets/theme";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CountdownTimer from "./countdownTimer";
import { FormattedMessage } from "react-intl";
import messages from "./messages";

export default function MachineInSetupBanner(props) {
    const { machineQuery } = props;

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    function isLight(color) {
        if (color.length === 7) {
            const rgb = [
                parseInt(color.substring(1, 3), 16),
                parseInt(color.substring(3, 5), 16),
                parseInt(color.substring(5), 16),
            ];
            const luminance =
                (0.2126 * rgb[0]) / 255 +
                (0.7152 * rgb[1]) / 255 +
                (0.0722 * rgb[2]) / 255;
            return luminance > 0.5;
        }
        return false
    }

    return (
        <Box
            sx={{
                height: "50px",
                display: "flex",
                alignItems: "center",
                paddingLeft: "20px",
                paddingRight: "20px",
                marginBottom: "10px",
                direction: "row",
                justifyContent: "space-between",
                backgroundColor: new Date(machineQuery.data.machineInSetupUntil) > Date.now() ? "#1565C0" : colors.redAccent[600],
            }}
            onClick={props.onClick}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    direction: "row"
                }}
            >
                <Typography
                    variant="inherit"
                    sx={{ fontSize: '18px' }}
                >
                    <InfoOutlinedIcon sx={{ marginRight: '10px', marginBottom: '4px' }} />
                </Typography>
                <Typography
                    variant="inherit"
                    sx={{ fontSize: '18px' }}
                >
                    <FormattedMessage {...messages.machineInSetup} />
                </Typography>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    direction: "row"
                }}
            >
                <Typography
                    variant="inherit"
                    sx={{ fontSize: '18px', marginLeft: '20px' }}
                >
                    { new Date(machineQuery.data.machineInSetupUntil) > Date.now() ? <FormattedMessage {...messages.machineInSetupEndsIn} /> : <FormattedMessage {...messages.machineInSetupLate} /> }
                    <CountdownTimer maxClosedDate={machineQuery.data.machineInSetupUntil} showSeconds={false} showCountUp={true}/>
                </Typography>
            </Box>
        </Box>
    )
}